/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AutomatedProcessGetProcessInstanceDiagram$Params {
  processInstanceId: string;
}

export function automatedProcessGetProcessInstanceDiagram(http: HttpClient, rootUrl: string, params: AutomatedProcessGetProcessInstanceDiagram$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetProcessInstanceDiagram.PATH, 'get');
  if (params) {
    rb.path('processInstanceId', params.processInstanceId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/png', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

automatedProcessGetProcessInstanceDiagram.PATH = '/automated-process/process-instance/{processInstanceId}/diagram';